import React, { useEffect, useState } from "react";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../../translations/subMenuItems.json';
import commonTranslation from '../../../translations/common.json';
import type { SlideShow } from "../../../model/Veille";
import useVeille from '../../../redux/Hooks/Kiosk/useVeille';
import Button from "../../Common/Button";
import TextField from "./../TextField";
import { defaultTimeoutSeconds } from "../../../model/Configuration";

const SlideShowChange = (props: {
  data: SlideShow | undefined,
  saveData: Function
}) => {
  const locale = useLocale();
  const veille = useVeille();
  const [urls, setUrls] = useState<Array<string>>(veille?.slideShow?.sources || []);
  const [addedUrl, setAddedUrl] = useState<string>('');
  const [timerToNextComponent, setTimerToNextComponent] = useState<number | undefined>(props.data?.timeBeforeSwitch || defaultTimeoutSeconds);
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    setChanged(true);
  }, [urls, addedUrl, timerToNextComponent])

  useEffect(() => {
    setChanged(false);
  }, [])

  const handleChangeUrl = (event: React.FormEvent<HTMLInputElement>) => {
    const key = event.currentTarget.getAttribute('key');
    if(key) {
      var temp = [...urls];
      temp[parseInt(key)] = event.currentTarget.value;
      setUrls(temp);
    }
  }

  const handleAddUrl = (event: React.FormEvent<HTMLInputElement>) => {
    setAddedUrl(event.currentTarget.value);
  }
  
  const handleChangeTimer = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === '') {
      setTimerToNextComponent(undefined);
    } else {
      const val = parseInt(event.currentTarget.value);
      val && setTimerToNextComponent(parseInt(event.currentTarget.value));
    }
  }

  const handleApply = () => {
    var newSources = [...urls];
    if(addedUrl !== '') {
      newSources.push(addedUrl);
      setUrls(newSources);
      setAddedUrl('');
    } 
    props.data ?
      props.saveData({
        ...props.data,
        sources: newSources,
        timeBeforeSwitch: timerToNextComponent || defaultTimeoutSeconds
      })
      :
      props.saveData({
        activated: false,
        sources: newSources,
        timeBeforeSwitch: timerToNextComponent || defaultTimeoutSeconds
      })

    setChanged(false);
  }

  const handleRemove = (index: number) => {
    var temp = [...urls];
    temp.splice(index, 1);
    setUrls(temp);
  }

  return (
    <div className="w-full flex flex-col border border-black rounded-sm gap-1 my-1 px-4 py-2">
      {urls.map((url, index) => {
        return (
          <div key={index} className="flex flex-row justify-between">
            <TextField
              label={`URL ${index+1}:`}
              onChange={handleChangeUrl}
              value={url}
            />
            <div
              className="w-4 h-4 bg-white border border-red-800 text-red-500 font-bold flex justify-center items-center cursor-pointer"
              onClick={() => handleRemove(index)}
            >
              X
            </div>
          </div>
        )
      })}
      <TextField
        label={translation[locale]?.veille.slideshowaddurl || translation["fr-FR"].veille.slideshowaddurl}
        onChange={handleAddUrl}
        value={addedUrl}
      />
      <TextField
        label={translation[locale]?.veille.slideshowtimer || translation["fr-FR"].veille.slideshowtimer}
        onChange={handleChangeTimer}
        value={timerToNextComponent}
      />
      {changed &&
        <div className="flex justify-center mt-1">
          <Button
            onClick={handleApply}
            label={commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          >
            {commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          </Button>
        </div>
      }
    </div>
  );
};

export default SlideShowChange;

